import { merchantServerEndpoint, isNull } from '../utils/common';
import { API, ERRORS } from '../constant';
import { get } from '../utils/http';

/**
 * Fetch merchant configuration based on mid
 *
 * @param {string} mid - merchant id
 * @returns {Promise<Object>} - Promise object
 */

export function config(mid) {
  if (isNull(mid)) {
    return Promise.reject(new Error(ERRORS.MID));
  }

  return new Promise((resolve, reject) => {
    get
      .call(this, `${merchantServerEndpoint(API.MERCHANT_CONFIG)}/${mid}`)
      .then(data => {
        const { merchantPreferenceInfos, resultInfo } = (data && data.body) || {};
        if (resultInfo && resultInfo.resultStatus === 'S' && merchantPreferenceInfos) {
          const response = {};
          const checkout = merchantPreferenceInfos.CHECKOUT;
          checkout.payMode.order = checkout.payMode.order.map(mode => mode.type.toUpperCase());
          /* isGradientEffectEnable key added to configuration for further use */
          checkout.isGradientEffectEnable = merchantPreferenceInfos.isGradientEffectEnable || false;
          response.configuration = checkout;
          resolve(response);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function configPayload(mid) {
  return {
    targetURL: `${merchantServerEndpoint(API.MERCHANT_CONFIG)}/${mid}`,
    method: 'GET'
  };
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/merchant.js